import {commonStyles} from '../annotation/commonStyles'
import {containerStyles} from '../annotation/containerStyles'
import {toStyleProperties} from '../annotation/toStyleProperties'
import {getDefaultCss} from '../annotation/utils/getDefaultCss'
import {addOrUpdateFeatures} from '../define/utils/ComponentFeature'
import {cfDisableComponentRemove, cfHideFromComponentPalette} from '../define/utils/integratedComponentFeatures'
import {Model} from '../define/utils/Model'
import {DefaultWrapper} from './DefaultWrapper'

const {height} = commonStyles
const {flexDirection, gap} = containerStyles
export const screenStyleProperties = toStyleProperties({
  ...containerStyles,
  ...commonStyles,
  height: height.setup({default: '100%'}),
  flexDirection: flexDirection.default('column'),
  gap: gap.default('10px')
})

const defaultCss = getDefaultCss(screenStyleProperties)

const screenFeatures = addOrUpdateFeatures({},
  {name: cfHideFromComponentPalette, value: true},
  {name: cfDisableComponentRemove, value: true}
)

const typeName = 'Screen'

/**
 * Form viewer screen metadata. **Internal use only.**
 */
export const screenModel = new Model(DefaultWrapper, typeName, undefined,
  undefined, undefined, undefined, defaultCss, undefined, typeName, 'container',
  'readOnly', undefined, undefined, 'disabled', undefined, screenFeatures)
